const routes = {
  CHECKOUT: '/checkout',
  SHOP: '/shop',
  PRODUCT_DETAIL: '/shop/item-details?id=KEY',
};

export default routes;
